module.exports = __webpack_public_path__ + "media/fonts/microgramma_d_extended_bold-webfont-f5539d9403df4b8bf111a6af11122358.woff";